import { useSelector } from "react-redux";
import { isInDevelopment } from "../config";

const DeveloperButton = () => {
  const currentUser = useSelector((st) => st.currentUser);
  const currentKlausur = useSelector((st) => st.currentKlausur);
  const companies = useSelector((st) => st.companies);
  const textbausteine = useSelector((st) => st.textbausteine);
  const currentCompany = useSelector((st) => st.currentCompany);
  const klausuren = useSelector((st) => st.klausuren);
  const schuelerList = useSelector((st) => st.schueler);
  const handleClick = () => {
    console.log({
      currentUser,
      currentKlausur,
      companies,
      textbausteine,
      currentCompany,
      klausuren,
      schuelerList,
    });
  };
  console.log({isInDevelopment})
  if(!isInDevelopment) return null
  return (
    <button className="btn btn-outline-dark my-3" onClick={handleClick}>
      Developer
    </button>
  );
};
export default DeveloperButton;
